import React, { useState } from "react";
import harness from "../assets/images/harness.png";

function ProductGallery({ images = [] }) {


  const [active, setActive] = useState(0);

const galleryImages =
  images.length > 0
    ? images.map(img => `${img}`)
    : [harness];


  return (
    <div style={styles.wrapper}>
      
      <div style={styles.mainImageBox}>
      <img src={galleryImages[active]} style={styles.mainImage} />
      </div>

      <div style={styles.thumbRow}>
      {galleryImages.map((img, i) => (
          <div
            key={i}
            onClick={() => setActive(i)}
            style={{
              ...styles.thumbBox,
              ...(active === i ? styles.selected : {})
            }}
          >
            <img src={img} style={styles.thumbImg} />
          </div>
        ))}
      </div>

    </div>
  );
}

export default ProductGallery;

const styles = {

 wrapper: {
  width: "70%",        // slightly smaller than the column
  maxWidth: 420,       // keeps it controlled
  margin: "0 auto",    // centers it
  display: "flex",
  flexDirection: "column",
  alignItems: "center"
},
 mainImageBox: {
  width: 470,
  height: 520,
  background: "#f6f7f9",
  borderRadius: 18,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",

  boxShadow:
    "0 35px 80px rgba(0,0,0,0.12), 0 10px 30px rgba(0,0,0,0.06)"
},
 mainImage: {
  width: "90%",
  height: "90%",
  objectFit: "contain"
},

  thumbRow: {
    display: "flex",
    gap: 20,
    marginTop: 30
  },

  thumbBox: {
    width: 85,
    height: 85,
    background: "#f6f7f9",
    borderRadius: 14,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    boxShadow: "0 8px 18px rgba(0,0,0,0.08)"
  },

  thumbImg: {
    width: "80%",
    objectFit: "contain"
  },

  selected: {
    border: "3px solid #4A8CFF"
  }

};